import AccountSettingsHeader from '../../../../components/account/settings/AccountSettingsHeader.tsx';
import AccountLayout from '../../../../components/layouts/AccountLayout.tsx';
import { useContests } from '../../../../components/contests/contestsQueries.ts';
import { PulseLoader } from '../../../../components/loaders/PulseLoader.tsx';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';

function AccountManagementContestsListPage() {
    const result = useContests();

    return (
        <AccountLayout>
            <AccountSettingsHeader title={'Zarządzanie konkursami'} backButtonIsVisible />
            {result.isLoading && <PulseLoader description="Ładowanie ..." />}
            {result.isSuccess && <div className={''}>
                <ul className="bg-neutral-950 rounded-lg mt-2 overflow-hidden text-neutral-200">
                    {result.data.data.items.map((contest, index) =>
                        <li key={contest.id}
                            className={`relative flex justify-between items-center hover:bg-neutral-700 p-3 px-2 border-neutral-600 hover:text-white transition ${index < result.data.data.items.length - 1 ? 'border-b' : ''}`}>
                            <p>{contest.title}</p>
                            <ChevronRightIcon className="w-7 h-7" />
                            <Link className="absolute inset-0" to={`/ustawienia/konkursy/${contest.id}`} />
                        </li>,
                    )}
                </ul>
            </div>
            }
        </AccountLayout>
    );
}

export default AccountManagementContestsListPage;